import { FC } from "react";
import "./HeaderTitle.scss";

export const HeaderTitle: FC = () => {
    return (
        <div className="header-title">
            <div className="title">Lernen aus der Praxis</div>
        </div>
    );
};
